import { State } from '@uplift/api';
import { AddressType } from '@uplift/types';

export const getFormattedAddressParts = (
  addressValues: Omit<AddressType, 'state'>,
  stateProfile?: State,
  options?: { stateName: 'fullName' | 'shortName' }
) => {
  const stateName = options?.stateName ? stateProfile?.[options.stateName] : stateProfile?.fullName;

  const { address1, address2, city, zip } = addressValues;
  const address = [ address1, address2 ].filter(x => x).join(', ');
  const addressCityState = [ city, stateName, zip ].filter(x => x).join(', ');
  const fullAddress = [ address, addressCityState ].join(', ');

  return { address, addressCityState, fullAddress };
};
